import React from 'react';
import { LineChart as RechartsLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import './_charts.scss';

const LineChart = ({ data, title, dataKey, xAxisKey = 'date', color = '#007bff', height = 300 }) => {
  const toTitleCase = (text) => {
    if (typeof text !== 'string') return text;
    return text
      .replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const formatXAxis = (tickItem) => {
    if (xAxisKey === 'date') {
      const d = new Date(tickItem);
      return isNaN(d.getTime()) ? tickItem : d.toLocaleDateString();
    }
    return typeof tickItem === 'string' ? toTitleCase(tickItem) : tickItem;
  };

  const formatTooltip = (value, name) => {
    const prettyName = toTitleCase(name);
    if (name === 'revenue') {
      return [`PKR ${value.toLocaleString()}`, 'Revenue'];
    }
    return [value, prettyName];
  };

  return (
    <div className="chart-container">
      <h6 className="chart-title">{title}</h6>
      <ResponsiveContainer width="100%" height={height}>
        <RechartsLineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey={xAxisKey} 
            tickFormatter={formatXAxis}
            stroke="#666"
            fontSize={12}
          />
          <YAxis stroke="#666" fontSize={12} />
          <Tooltip 
            formatter={formatTooltip}
            labelFormatter={(label) => {
              if (xAxisKey === 'date') {
                const d = new Date(label);
                return `Date: ${isNaN(d.getTime()) ? label : d.toLocaleDateString()}`;
              }
              return toTitleCase(String(label));
            }}
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
          />
          <Legend />
          <Line 
            type="monotone" 
            dataKey={dataKey} 
            stroke={color} 
            strokeWidth={2}
            dot={{ fill: color, strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, stroke: color, strokeWidth: 2 }}
            name={toTitleCase(dataKey)}
          />
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChart;
